import {refreshToken} from "./AuthService";
import {ftAccessToken, ftRefreshToken} from "../constants/Constants";
import {properties} from "../properties";

export function fetchUserSettings(firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        fetchUserSettings(false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to fetch content."));
                }
            }
        };
        xhttp.open("GET", properties.host + "/user-settings/get", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.send();
    });
}

export function saveUserSettings(userSettings, firstCall) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        let xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if (this.status === 403 && firstCall) {
                    // If the token is expired, try to refresh it
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        // Retry the original request with the new access token
                        saveUserSettings(userSettings, false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: 403 });
                    });
                } else {
                    reject(new Error("Failed to fetch content."));
                }
            }
        };
        xhttp.open("POST", properties.host + "/user-settings/save", true);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.send(JSON.stringify(userSettings));
    });
}